import { ReactElement, useMemo, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStopwatch as IntervalIcon } from '@fortawesome/free-solid-svg-icons';

import { formmaterSecondToHumanizeTime } from '~utils/formatter';
import { toAbsoluteUrl } from '~utils/assetsHelpers';

import { WorkIntervalInfoProps } from './types';
import DescriptionWithIconBox from '../DescriptionWithIconBox';

const WorkIntervalInfo = ({
  interval,
  intervalReal,
  fontSize = 14,
  fontWeight,
  withTooltip = false,
  useCustomIcon = false,
}: WorkIntervalInfoProps): ReactElement => {
  const Icon = useMemo(
    () =>
      useCustomIcon ? (
        <img src={toAbsoluteUrl('/icons/icon_clock.svg')} alt="Time Icon" />
      ) : (
        <FontAwesomeIcon icon={IntervalIcon} />
      ),
    [useCustomIcon],
  );

  const text = useMemo(() => {
    let baseText = formmaterSecondToHumanizeTime(interval ?? 0);

    if (intervalReal !== undefined) {
      baseText += ` (${formmaterSecondToHumanizeTime(intervalReal ?? 0)})`;
    }
    return baseText;
  }, [interval, intervalReal]);

  const tooltipMessage = useMemo(() => {
    if (!withTooltip) return undefined;

    let baseTooltip = 'Duración estimada';

    if (!intervalReal !== undefined) {
      baseTooltip += ` (Duración real)`;
    }

    return baseTooltip;
  }, [intervalReal, withTooltip]);

  return (
    <DescriptionWithIconBox
      icon={Icon}
      description={text}
      size={fontSize}
      iconTooltip={tooltipMessage}
      fontWeight={fontWeight}
    />
  );
};

export default memo(WorkIntervalInfo);
